"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadModal = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericFileUploadModal_1 = require("components/modals/GenericFileUploadModal");
var Container_1 = require("components/modals/GenericFileUploadModal/Container");
var messageActions = require("@caddigital/sok-reducers/lib/actions/bid/message");
var bidMessageAttachments_1 = require("actions/bidMessageAttachments");
var sok_ui_1 = require("@caddigital/sok-ui");
var translate_1 = require("utils/translate");
var FileList_1 = require("./FileList");
var Types = require("types");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        bidMessageAttachments: state.bidMessageAttachments,
        currentUser: state.auth.current.user,
        message: state.bid.message,
        attachmentsFolder: state.bid.current.attachments,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function (session) { return (dispatch(bidMessageAttachments_1.default.toggleModalStatus()),
        dispatch(bidMessageAttachments_1.default.resetCurrentUploadStatus(session))); },
    startUpload: function (files, parent) {
        return dispatch(messageActions.prepareUploadRequest(parent, files));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidParticipantsTools'), (0, recompose_1.withState)('selected', 'setSelected', []), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), recompose_1.pure);
exports.UploadModal = enhance(function (props) {
    var disabled = props.message.prepareStatus === 'FETCHING' ||
        props.bidMessageAttachments.currentUploadStatus.status === 'UPLOADING' ||
        props.bidMessageAttachments.currentUploadStatus.uploadSessionStatus ===
            'CREATING';
    return (React.createElement(GenericFileUploadModal_1.default, { onRequestClose: function () {
            return props.toggleModal(props.bidMessageAttachments.currentUploadStatus.session);
        }, isOpen: props.bidMessageAttachments.modalState.isOpen },
        React.createElement(Container_1.Container, null,
            React.createElement("div", { className: 'description' }, (0, translation_1.getLocalization)('bid/message/upload/description')),
            React.createElement(FileList_1.default, null),
            (props.message.prepareStatus === 'FETCHING' ||
                props.bidMessageAttachments.currentUploadStatus
                    .uploadSessionStatus === 'CREATING') && (React.createElement("div", null, (0, translation_1.getLocalization)('bid/message/upload/preparingUpload')))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', disabled: disabled || props.bidMessageAttachments.files.length === 0, onClick: function () {
                    return props.attachmentsFolder &&
                        props.startUpload(props.bidMessageAttachments.files, props.attachmentsFolder);
                } }, (0, translation_1.getLocalization)('bid/message/upload/upload')),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', disabled: disabled, onClick: function () {
                    return props.toggleModal(props.bidMessageAttachments.currentUploadStatus.session);
                } }, (0, translation_1.getLocalization)('bid/message/upload/close')))));
});
